import * as Actions from '../actionsgazeta';

const initialState = [];

const categoriaNoticias = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_CATEGORIA_NOTICIA_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_CATEGORIA_NOTICIA_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default categoriaNoticias;
